export default __webpack_public_path__ + "static/Entenda0143-cb615d3d57cdec96c15c80706e47f076.jpg";